import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./bootstrap-theme.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../../assets/fonts/fonts.css";
import "./styles.css";
import App from "./App.jsx";

const IS_STATIC = typeof __STATIC_BUILD__ !== "undefined" && !!__STATIC_BUILD__;
const Router = IS_STATIC ? HashRouter : BrowserRouter;

const el = document.getElementById("root");
createRoot(el).render(
  <StrictMode>
    <Router>
      <App />
    </Router>
  </StrictMode>,
);

// Service worker: only in the static (S3) build. The SW precaches the snapshot
// and serves it stale-while-revalidate so the site loads instantly and offline.
// In any other context (dev, the API-backed build) we unregister any leftover
// SW so it can never serve stale assets.
const BUILD_KEY = "pmp_build";
if ("serviceWorker" in navigator) {
  if (IS_STATIC) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .then((reg) => {
          const checkForUpdate = () => reg.update().catch(() => {});
          // Look for a new build on first load and whenever the tab refocuses.
          checkForUpdate();
          document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible") checkForUpdate();
          });
          // version.json is the freshness flag: if its hash differs from the one
          // we last saw, a new build is live — pull the updated SW in now.
          fetch("/version.json", { cache: "no-store" })
            .then((r) => (r.ok ? r.json() : null))
            .then((info) => {
              if (!info?.version) return;
              const prev = localStorage.getItem(BUILD_KEY);
              if (info.version !== prev) {
                localStorage.setItem(BUILD_KEY, info.version);
                if (prev !== null) checkForUpdate();
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    });
  } else {
    navigator.serviceWorker
      .getRegistrations()
      .then((regs) => regs.forEach((r) => r.unregister()))
      .catch(() => {});
  }
}
